/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Carriage_SeiInputs */



/**
* | output |
* | --- |
* | "In the video stream (A/53 SEI)" |
*
* @param {Embed_Captions_Local_Carriage_SeiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_carriage_sei = /** @type {((inputs?: Embed_Captions_Local_Carriage_SeiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Carriage_SeiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dans le flux vidéo (A/53 SEI)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Videostream (A/53 SEI)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nel flusso video (A/53 SEI)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В видеопотоке (A/53 SEI)")
	if (locale === "es") return /** @type {LocalizedString} */ ("En la secuencia de vídeo (A/53 SEI)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在视频流（A/53 SEI）中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオストリーム（A/53 SEI）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो स्ट्रीम में (A/53 SEI)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("No fluxo de vídeo (A/53 SEI)")
	return /** @type {LocalizedString} */ ("In the video stream (A/53 SEI)")
});